import * as React from 'react';
import styled from 'styled-components';

import { InfoBox } from '@longline/aqua-ui/containers/InfoBox';
import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';
import { CountryFormatter } from '@longline/aqua-ui/formatters/CountryFormatter';
import { DivisionFormatter } from '@longline/aqua-ui/formatters/DivisionFormatter/DivisionFormatter';
import { NumberFormatter } from '@longline/aqua-ui/formatters/NumberFormatter';
import { Icon } from '@longline/aqua-ui/controls/Icon';
import { SVG } from '@longline/aqua-ui/svg';

import { ISystem } from '../../api/models/ISystem';
import { useSystemsContext } from '../../panes/SystemPane/ISystemsContext';
import { Can } from '../../ui/Can';

interface IProps {
  value?: ISystem;
  onClose: () => void;
}

const SystemInfoBox = (props: IProps) => {
  const ctx = useSystemsContext();

  // Optional because <ListView aux> injects the active item; render nothing
  // if no item is selected.
  if (!props.value) return null;
  const system = props.value;

  const handleView = () => {
    ctx.setSystem(system);
    ctx.setSystemReady('loading');
    ctx.setMode('view');
  }

  const handleLoad = () => {
    ctx.parseSystem();
  }

  return (
    <InfoBox
      padded
      header={<HeaderText>{system.name}</HeaderText>}
      width={300}
      footer={<>
        <Can permission="view_system">
          <TertiaryButton onClick={handleView}>DETAILS</TertiaryButton>
        </Can>
        <TertiaryButton onClick={handleLoad}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px'}}>{ctx.systemReady === 'loading' && <Icon color="#333" url={SVG.Icons.CircleNotch} animated/>} LOAD</div>
        </TertiaryButton>
      </>}
    >
      {system.country && <InfoBox.Row name="Country" value={<CountryFormatter value={system.country}/>}/>}
      {system.division && <InfoBox.Row name="Division" value={<DivisionFormatter value={system.division}/>}/>}
      <Can permission="view_system">
        <InfoBox.Row name="Users" value={<NumberFormatter value={system.users_count ?? 0} decimals={0}/>}/>
        <InfoBox.Row name="Layers" value={<NumberFormatter value={system.layers_count ?? 0} decimals={0}/>}/>
        <InfoBox.Row name="Driver sets" value={<NumberFormatter value={system.driversets_count ?? 0} decimals={0}/>}/>
      </Can>
    </InfoBox>
  )
}

const HeaderText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export { SystemInfoBox }
